class ResourceComposition {

  label = null;
  groups = [];
  includesUserResources = false;
  isHiddenOnEmpty = false;

  constructor(label = "") {
    this.label = label;
  }

  toggleGroup(group){
    if( this.groups.some(  grp => grp.uuid === group.uuid)){
      this.groups = this.groups.filter( grp => grp.uuid !== group.uuid);
    } else {
      this.groups = [...this.groups, group];
    }
  }

  isEmpty() {
    return this.includesUserResources === false && this.groups.length === 0;
  }

  toJson() {
    return {
      label: this.label,
      groups: this.groups.map(group => group.id),
      includesUserResources: this.includesUserResources,
      isHiddenOnEmpty: this.isHiddenOnEmpty,
    };
  }

  static fromPayload(payload) {

    console.log(payload);

    const composition = new ResourceComposition(payload.label);
    composition.groups = payload.groups;
    composition.includesUserResources = payload.includesUserResources;
    composition.isHiddenOnEmpty = payload.metadata ? payload.metadata.isHiddenOnEmpty || false : false;

    return composition;
  }

}

export { ResourceComposition };
